import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorksSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'UserPlus',
      title: 'Create Anonymous Profile',
      description: 'Sign up with just your email or mobile number. Choose a display name and set your privacy preferences. No real names required.',
      features: ['Email/Mobile verification', 'Username selection', 'Age confirmation (18+)']
    },
    {
      number: '02',
      icon: 'Settings',
      title: 'Customize Your Privacy',
      description: 'Control your visibility with advanced privacy settings. Blur photos, hide your face, and decide who can contact you.',
      features: ['Photo blur controls', 'Message permissions', 'Location privacy']
    },
    {
      number: '03',
      icon: 'Users',
      title: 'Connect & Explore',
      description: 'Browse profiles anonymously, send secure messages, and build meaningful connections in a judgment-free environment.',
      features: ['Advanced search filters', 'Secure messaging', 'Match recommendations']
    }
  ];

  return (
    <section id="how-it-works" className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            How It Works
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Get started in three simple steps and begin your discreet journey today
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {steps?.map((step, index) => (
            <div key={index} className="relative">
              {index < steps?.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-primary to-secondary opacity-20 -translate-x-1/2" />
              )}
              
              <div className="bg-card rounded-xl p-6 md:p-8 shadow-warm hover:shadow-warm-lg transition-smooth relative z-10">
                <div className="flex items-start gap-4 md:gap-5 mb-4 md:mb-5">
                  <div className="flex-shrink-0">
                    <div className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold bg-gradient-to-br from-primary to-secondary bg-clip-text text-transparent opacity-20">
                      {step?.number}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center mb-3 md:mb-4">
                      <Icon name={step?.icon} size={24} className="md:w-7 md:h-7" color="#FFFFFF" />
                    </div>
                    <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2 md:mb-3">
                      {step?.title}
                    </h3>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-4">
                      {step?.description}
                    </p>
                    <ul className="space-y-2">
                      {step?.features?.map((feature, idx) => (
                        <li key={idx} className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                          <Icon name="Check" size={16} color="var(--color-success)" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;